import { Stack } from '@mui/material';

import {
  DIAGNOSTIC_ASSESSMENT_OPTIONS,
  QuestionnaireSectionLabel,
  QUESTIONNAIRE_PAGE_BOX_SX,
} from '../../../../common';
import {
  AutoSaveList,
  EMPTY_REFERRAL_VALUES,
  ReferralFields,
  getReferralDeleteMessage,
} from '../../../../../common';
import { REFERRAL_FORM_SCHEMA } from './validationSchema';
import {
  getIntakeReferralRowLabel,
  mapIntakeReferralRowToValues,
  toIntakeReferralFieldPayload,
} from './utils';
import { useIntakeReferrals } from './hooks';
import { useIntakeQuestionnaireLoading } from '../../../hooks';
import { FORTA_BLUE } from '../../../../../../utils/colors';

import type {
  IIntakeReferral,
  IntakeReferralPayload,
} from '../../../../../../store/questionnaires/intake';
import type { ReferralFormValues } from '../../../../../common';

export default function ReferralForm() {
  const { referrals, isSaving, create, update, remove } = useIntakeReferrals();
  const isLoading = useIntakeQuestionnaireLoading();

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Referral history
      </QuestionnaireSectionLabel>
      <Stack gap={2} textAlign="left" sx={QUESTIONNAIRE_PAGE_BOX_SX}>
        <AutoSaveList<ReferralFormValues, IIntakeReferral, IntakeReferralPayload>
          addButtonLabel="Add referral"
          disabled={isLoading}
          emptyValues={EMPTY_REFERRAL_VALUES}
          entries={referrals}
          getDeleteConfirm={(row) => ({
            title: 'Confirm referral deletion?',
            message: getReferralDeleteMessage({
              provider_name: row.provider_name,
              referral_date: row.diagnosis_date,
            }),
          })}
          getRowKey={(row) => row.id}
          getRowLabel={getIntakeReferralRowLabel}
          isSaving={isSaving}
          mapRowToValues={mapIntakeReferralRowToValues}
          newEntryLabel="New referral"
          onCreate={create}
          onDelete={remove}
          onUpdate={update}
          requiredMessage="At least one referral is required"
          renderFields={({ formik, disabled, readOnly, saveField, backgroundColor }) => (
            <ReferralFields
              backgroundColor={backgroundColor}
              diagnosisToolOptions={DIAGNOSTIC_ASSESSMENT_OPTIONS}
              disabled={disabled}
              formik={formik}
              readOnly={readOnly}
              saveField={saveField}
            />
          )}
          toFieldPayload={toIntakeReferralFieldPayload}
          validationSchema={REFERRAL_FORM_SCHEMA}
        />
      </Stack>
    </>
  );
}
